/* eslint-disable no-console */
import { Configuration, LogLevel, RedirectRequest } from '@azure/msal-browser';
import * as logger from '../utils/logger';
import { envConfigs } from '../config/envConfigs';

const CLIENT_ID = envConfigs.REACT_APP_AAD_APP_CLIENT_ID;
const TENANT_NAME = envConfigs.REACT_APP_TENANT_NAME;
const USER_FLOW_NAME = envConfigs.REACT_APP_USER_FLOW_NAME;
const AUTHORITY = envConfigs.REACT_APP_AUTHORITY;

export const b2cPolicies = {
  names: {
    signUpSignIn: USER_FLOW_NAME,
  },
  authorities: {
    signUpSignIn: {
      authority: AUTHORITY,
      // Client id should be included if we want to retrieve accessToken
      scopes: ['openid', CLIENT_ID, 'email'],
    },
  },
  authorityDomain: TENANT_NAME,
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    // This is the ONLY mandatory field that you need to supply.
    clientId: CLIENT_ID,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    // Mark your B2C tenant's domain as trusted.
    knownAuthorities: [b2cPolicies.authorityDomain],
    // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    redirectUri: '/',
    // Indicates the page to navigate after logout.
    postLogoutRedirectUri: '/',
    // If "true", will navigate back to the original request location before processing the auth code response.
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    cacheLocation: 'localStorage',
    // Set this to "true" if you are having issues on IE11 or Edge
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            logger.error(message);
            return;
          case LogLevel.Info:
            // logger.info(message);
            return;
          case LogLevel.Verbose:
            logger.debug(message);
            return;
          case LogLevel.Warning:
            logger.warn(message);
            return;
          default:
            logger.log(message);
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */

export const loginRequest: RedirectRequest = {
  scopes: b2cPolicies.authorities.signUpSignIn.scopes,
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */

export const protectedResources = {
  api: {
    scopes: envConfigs.REACT_APP_API_USER_SCOPES.split('|'),
  },
};
